<div class="row">
  <div class="col-12">
    <div class="card card-body">
      <div
        class="d-flex justify-content-between align-items-center mb-3 header"
      >
        <h4 class="card-title mb-0">
          <span class="lstick"></span>User Membership Listing
        </h4>
      </div>

      <div class="table-responsive" *ngIf="!loading">
        <table class="table table-striped border mt-4">
          <thead class="table-light">
            <tr>
              <th scope="col">Username</th>
              <th scope="col">User Email</th>
              <th scope="col">Subscription Plan</th>
              <th scope="col">Price</th>
              <th scope="col">Is Active</th>
              <th scope="col">Timing</th>
              <th scope="col">Duration</th>
              <th scope="col">Purchased Date</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let membership of membershipList; let i = index">
              <td>{{ membership?.user_id?.username }}</td>
              <td>{{ membership?.user_id?.email }}</td>
              <td>
                <p
                  placement="top"
                  [ngbTooltip]="membership?.membershipId?.name"
                >
                  {{
                    membership?.membershipId?.name
                      ? membership?.membershipId?.name?.length > 30
                        ? (membership?.membershipId?.name | slice : 0 : 30) +
                          "..."
                        : membership?.membershipId?.name
                      : "-"
                  }}
                </p>
              </td>
              <td>
                <p placement="top">
                  {{ membership?.countryObject?.currency }}
                  {{ membership?.chargeableAmount / 100 }}
                </p>
              </td>
              <td>
                <span
                  class="badge text-white"
                  [ngClass]="membership?.active ? 'bg-success' : 'bg-danger'"
                >
                  {{ membership?.active ? "Yes" : "No" }}
                </span>
              </td>
              <td>
                <p placement="top">{{ membership?.timing | titlecase }}</p>
              </td>
              <td>
                <p placement="top">{{ membership?.duration }}</p>
              </td>
              <td>{{ membership.created_at | date : "short" }}</td>
              <td>
                <button
                  class="btn btn-sm btn-info"
                  (click)="handleView(membership._id)"
                  ngbTooltip="View"
                >
                  <i class="fa fa-eye"></i>
                </button>
              </td>
            </tr>

            <tr *ngIf="membershipList?.length === 0 && !loading">
              <td colspan="9" class="text-center text-muted">
                No membership records found.
              </td>
            </tr>
          </tbody>
        </table>

        <div
          class="d-flex justify-content-center mt-5"
          *ngIf="membershipList?.length != 0"
        >
          <ngb-pagination
            [(page)]="page"
            [pageSize]="pageSize"
            [collectionSize]="totalCount"
            [maxSize]="7"
            [rotate]="true"
            [ellipses]="false"
            [boundaryLinks]="true"
            (pageChange)="loadPage($event)"
          ></ngb-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
